import { enUS, frFR, deDE, itIT } from '@mui/x-data-grid/locales';

export const getLocaleForGrid = (languageText: string) => {
  switch (languageText) {
    case 'en_US':
      return enUS;
    case 'fr_FR':
      return frFR;
    case 'de_DE':
      return deDE;
    case 'it_IT':
      return itIT;
    default:
      return enUS;
  }
};

/**
 * Checks whether two arrays contain the same elements, regardless of order.
 *
 * @param {string[]} initialArray - The initial array.
 * @param {string[]} updatedArray - The updated array.
 * @returns {boolean} - Returns `true` if both arrays contain the same elements, otherwise `false`.
 */
export function isArraysEqual(initialArray: string[], updatedArray: string[]): boolean {
  if (initialArray.length !== updatedArray.length) {
    return false;
  }

  return initialArray.every((element) => updatedArray.includes(element));
}
